/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWithVehicle32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M19.094 10.708h2.32c.418 0 .808.21 1.04.557l1.02 1.53h-3.38v1.5h4.689l4.239 1.06a1.951 1.951 0 011.328 1.142h-1.069a.75.75 0 100 1.5H30.5v.774h-3.385a2.743 2.743 0 00-5.277 0h-3.744v1.5h3.744a2.743 2.743 0 005.277 0H32v-3.024a3.452 3.452 0 00-2.614-3.348l-4.048-1.012-1.636-2.454a2.75 2.75 0 00-2.288-1.225h-2.32v1.5zm4.14 8.813a1.242 1.242 0 112.485 0 1.242 1.242 0 01-2.485 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M4.057 12.498a6.498 6.498 0 1112.996 0v2.705a6.49 6.49 0 01-2.63 5.222l.047.264c.08.446.39.817.816.974l3.43 1.264a3.66 3.66 0 012.395 3.434h-1.5a2.16 2.16 0 00-1.413-2.027l-2.17-.799a7.827 7.827 0 01-5.473 2.223 7.827 7.827 0 01-5.473-2.223l-2.17.8A2.16 2.16 0 001.5 26.36H0a3.66 3.66 0 012.394-3.434l3.43-1.264c.426-.157.737-.527.817-.974l.047-.264a6.49 6.49 0 01-2.63-5.222v-2.705zm8.936 8.456c.153.854.694 1.58 1.452 1.974a6.32 6.32 0 01-3.89 1.33 6.32 6.32 0 01-3.89-1.33 2.779 2.779 0 001.41-1.775 8.9 8.9 0 001.939.407l.16-1.492c-1.159-.124-1.83-.388-2.2-.584l-.064-.04a4.994 4.994 0 01-2.353-4.241v-2.705a4.998 4.998 0 018.508-3.558c-.14.074-.307.142-.502.202-.488.152-1.086.234-1.728.261a14.69 14.69 0 01-3.365-.276l-.315 1.467c.84.18 2.311.368 3.743.308.716-.03 1.454-.123 2.11-.327.331-.103.66-.24.961-.424.373.7.584 1.499.584 2.347v2.705a4.994 4.994 0 01-2.352 4.241l-.43.27.222 1.24zm-.594-8.228l.556 4.01H9.719v-1.5h1.514l-.32-2.304 1.486-.206z'
      />
    </svg>
  );
}

export default SvgWithVehicle32;
